import { SERVER_URL } from "../../../utils/constants";
import HttpRequest from "../../../utils/HttpRequest";

export const getItemsService = async (query: string, token: string) => {
  return await HttpRequest.get(`${SERVER_URL}/item${query}`, token);
};

export const searchItemsService = async (query: string, token: string) => {
  return await HttpRequest.get(`${SERVER_URL}/item/search${query}`, token);
};

export const updateItemService = async (
  itemId: string,
  data: any,
  token: string
) => {
  return await HttpRequest.update(
    `${SERVER_URL}/item/${itemId}`,
    data,
    token
  );
};

export const addItemService = async (data: any, token: string) => {
  return await HttpRequest.post(`${SERVER_URL}/item`, data, token);
};

export const deleteItemService = async (
  itemId: string,
  token: string
) => {
  return await HttpRequest.delete(`${SERVER_URL}/item/${itemId}`, token);
};
